






















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class Register extends Vue {
    
    private unitTree = [];
    private selUnit = [0];
    private resetForm = {
        phone: "",
        verify: "",
        password: ""
    };
    private rules = {
        phone: [{ required: true, message: '请输入手机号', trigger: 'blur' },],
        verify: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
    };

    created() {
    }

    onVerify() {
        this.$apis.getVerify(this.resetForm.phone)
            .then((res: any) => {
                this.$message({
                    type: 'success',
                    message: '验证码已发送，请注意查收!'
                });
            });
    }

    onReset() {
        (this.$refs.resetForm as HTMLFormElement).validate((valid: boolean) => {
            if (valid) {

                this.$apis.putReset(this.resetForm)
                    .then((res: any) => {
                        this.$message({
                            type: 'success',
                            message: '密码已成功修改!'
                        });
                    });
            }
        });
    }

    onLogin() {
        this.$router.push("/login");
    }
}
